import {
  ChangeDetectionStrategy,
  Component,
  Input,
  TemplateRef,
} from '@angular/core';
import { SideAvatarComponent } from '../side-avatar/side-avatar.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'auth-register-container',
  templateUrl: './register-container.component.html',
  styleUrl: './register-container.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SideAvatarComponent, TranslateModule],
})
export class RegisterContainerComponent {
  @Input() customTemplate?: TemplateRef<void>;
}
